<template>
  <div class="terms">
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.mainTitle"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.descriptionIntro"></div>
    <br/>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title1"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description1"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title2"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description2"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title3"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description3"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title4"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description4"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title5"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description5"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title6"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description6"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title7"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description7"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title8"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title81"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description81"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title82"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description82"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title83"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description83"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title84"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description84"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title85"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description85"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title9"></div>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title91"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description91"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title92"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description92"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title10"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description10"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title11"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description11"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title12"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description12"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title13"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description13"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title14"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description14"></div>
    <br>
    <div class="heading-3-bold popup-title" v-html="fields.field_one.value.title15"></div>
    <div class="paragraph-1" v-html="fields.field_one.value.description15"></div>
    <br>
<!--    <div class="paragraph-1" v-html="fields.field_one.value.description6"></div>-->

  </div>
</template>

<script>
export default {
  name: 'Terms',
  props: {
    fields: {
      type: Object
    }
  }
}
</script>

<style lang="scss">
@import "Terms.scss";
</style>
